import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HelpMeComponent } from './features/help-me/help-me.component';
import { AuthGuard, AdminOnlyGuard, SeoOnlyGuard, PebOnlyGuard, TagOnlyGuard, PebTagGuard, TagAndPebGuard, PlOnlyGuard, AdminAndPlGuard } from './shared/guards/authGuard';

const routes: Routes = [
  {
    path: 'auth',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./auth/auth.module').then(
        (m) => {
          return m.AuthModule
        }
      ),
  },
  {
    path: 'proposals',
    canActivate: [TagAndPebGuard],
    loadChildren: () =>
      import('./review-2/review-2.module').then(
        (m) => {
          return m.Review2Module
        }
      ),
  },
  {
    path: 'docs',
    canActivate: [PebTagGuard],
    loadChildren: () =>
      import('./docs/docs.module').then(
        (m) => {
          return m.DocsModule
        }
      ),
  },
  {
    path: 'review',
    canActivate: [PebTagGuard],
    loadChildren: () =>
      import('./review/review.module').then(
        (m) => {
          return m.ReviewModule
        }
      ),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, PlOnlyGuard],
    loadComponent: () => import('./admin/admin-home/admin-home.component').then(a=>a.AdminHomeComponent)
  },
  {
    path: 'admin/quads',
    canActivate: [AuthGuard, AdminAndPlGuard],
    loadComponent: () => import('./admin/quad-rank-view/quad-rank-view.component').then(a=>a.QuadRankViewComponent)
  },
  {
    path: 'admin/fulls',
    canActivate: [AuthGuard, AdminAndPlGuard],
    loadComponent: () => import('./admin/full-rank-view/full-rank-view.component').then(a=>a.FullRankViewComponent)
  },
  {
    path: 'admin/forceseo',
    canActivate: [AuthGuard, AdminOnlyGuard],
    loadComponent: () => import('./admin/force-seo-scores/force-seo-scores.component').then(a=>a.ForceSeoScoresComponent)
  },
  {
    path: 'help',
    loadComponent: () => import('./features/help-me/help-me.component').then(a=>a.HelpMeComponent)
  },
  {
    path: 'settings',
    canActivate: [AdminOnlyGuard],
    loadChildren: () =>
      import('./settings/settings.module').then(
        (m) => {
          return m.SettingsModule
        }
      ),
  },
  {
    path: 'full',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./full/full.module').then(
        (m) => {
          return m.FullModule
        }
      ),
  },
  {
    path: 'fy27',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./fy27/fy27.module').then(
        (m) => {
          return m.Fy27Module
        }
      ),
  },
  {
    path: 'quad',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./quad/quad.module').then(
        (m) => {
          return m.QuadModule
        }
      ),
  },
  {
    path: 'login',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./auth/auth.module').then(
        (m) => {
          return m.AuthModule
        }
      ),
  },
  { path: '', redirectTo: '/home', pathMatch: "full" },
  {
    path: 'home',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./home/home.module').then(
        (m) => {
          return m.HomeModule
        }
      ),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
